require('../../../../vendor/angular-ux-datagrid.vendor');
require('angular-readable-time');
const uirouter = require('@uirouter/angularjs');
const ngIdle = require('ng-idle');
const angularSanitize = require('angular-sanitize');
const uiBootstrap = require('angular-ui-bootstrap');
const uiSelect = require('ui-select');
const relativeDate = require('angular-relative-date');
const coreModule = require('gw-um-core/coreModule.js');

/*@ngInject*/
angular.module('gw-um-submission-grid', [
    angularSanitize,
    ngIdle,
    uirouter.default,
    uiBootstrap,
    uiSelect,
    relativeDate.default.name,
    'currencyFilter',
    'isoCurrency',
    'dibari.angular-ellipsis',
    'ux',
    coreModule
])
    .config(function () {})
    .run(function () {});

require('./submissionGridConstant') ;
require('./submissionGridComponent') ;
require('./baseSubmissionGridController') ;
require('./submissionGridController') ;
require('./submissionGrid.less') ;
require('./submissionGrid.tpl.html') ;

require('./submissionDetailsDrawer/submissionDetailsDrawerDirective') ;
require('./submissionDetailsDrawer/submissionDetailsDrawerDirective.tpl.html') ;
require('./submissionDetailsDrawer/scrollFixedGridArrowDirective') ;

require('./submissionDetailsDrawer/transactionGridTooltip/transactionGridTooltip') ;
require('./submissionDetailsDrawer/transactionGridTooltip/transactionGridTooltip.tpl.html') ;

require('./repository/loadSubmissionsRepository');

require('./rangeModal/rangeModal.tpl.html');
require('./rangeModal/rangeModalController');

module.exports = 'gw-um-submission-grid';
